import axios from "axios";
import { baseUrl } from "../../configs";

axios.defaults.withCredentials = true;

export async function connectEbay(authCode) {
  await axios.post(`${baseUrl}/auth/ebay/connect`, { code: authCode });
}
